import React, { EventHandler } from 'react'

export interface PillProps {
    text: string;
    onClick?: EventHandler<any>;
    showCross?: boolean;
}

const Pill = (props: PillProps) => {
  return (
    <>
        {!!props.text && (
          <div
            className="rounded-[0.625rem] border border-[#890526] px-3 py-1.5 text-sm text-[#890526] inline-flex flex-row items-center gap-2 cursor-pointer whitespace-nowrap shrink-0 max-w-full"
            onClick={props.onClick}
          >
            <span className="truncate">{props.text}</span>
            {props.showCross && (
              <img src="/cross.svg" alt="" className="w-3 h-3 shrink-0" />
            )}
          </div>
        )}
    </>
  )
}

export default Pill
